import { render, staticRenderFns } from "./AddAttributes.vue?vue&type=template&id=12025316&"
import script from "./AddAttributes.vue?vue&type=script&lang=js&"
export * from "./AddAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports